'use client';

import { useEffect } from 'react';
import { destinoRecuperacion } from '@/lib/recuperacion';

/** Lleva a /reset-password los enlaces de recuperación que caen en otra página. */
export default function RecuperacionRedirect() {
  useEffect(() => {
    const destino = destinoRecuperacion(window.location.pathname, window.location.hash);
    if (destino) window.location.replace(destino);
  }, []);
  return null;
}
